module.exports = __webpack_public_path__ + "img/jingli.27e68413.svg";